import { isEmpty } from 'lodash';
import { CustomValidateResolveType, MessagePlugin } from 'tdesign-react';

import { ISubCollection, SubCollectionType } from '@/interface/novel';

const validateStories: (
  data: any,
  isBanner: boolean
) => CustomValidateResolveType = (data, isBanner) => {
  if (isEmpty(data?.story)) {
    return { result: false, message: '请选择故事', type: 'error' };
  }
  if (isBanner && data?.story?.length < 5) {
    return { result: false, message: '最少选择5个故事', type: 'error' };
  }
  return true;
};

const validateMultiCollections = (collections: ISubCollection[] = []): boolean => {
  if (collections.length === 0) {
    MessagePlugin.error('至少需要一个榜单');
    return false;
  }

  const hasEmptyCollection = collections.some((item) => {
    if (item.type === SubCollectionType.NOVEL) {
      return (item.novels || []).length === 0;
    }
    if (item.type === SubCollectionType.AVG) {
      return (item.stories || []).length === 0;
    }

    MessagePlugin.error(`未知的子合集类型: ${item.type}`);
    return true;
  });

  if (hasEmptyCollection) {
    MessagePlugin.error('榜单内容不能为空，请检查每个子合集的配置');
    return false;
  }
  return true;
};

export { validateMultiCollections, validateStories };
